import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const textColor: AdminBlockTypeAttribute = {
  label: 'Show text color',
  key: 'textColor',
  inputType: AdminBlockAttributeInputType.COLOR_PICKER,
};

export default textColor;
